import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { TodoListItem } from '@unmind/design-system';
import { tracking } from 'App/Tracking';
import RoutePath from 'App/RoutePath';
import { useTodoListItemTracking } from '../hooks/useTodoListItemTracking';

export const PractitionerMatchingItem = ({
  remaining,
}: {
  remaining: number;
}) => {
  const { t: translate } = useTranslation('homepage', {
    keyPrefix: 'todo_list_section.matching_item',
  });
  const { trackClicked } = useTodoListItemTracking('practitioner-matching', {
    shown: true,
    completed: false,
  });

  return (
    <TodoListItem
      titleAsChild
      description={translate('description', { remaining })}
      thumbnail={{ icon: 'practitioner', tone: 'tertiary' }}
      cta={translate('cta')}
    >
      <Link
        to={RoutePath.BookMatch}
        onClick={() => {
          tracking.track('homepage-find-your-match-clicked', {
            source: 'homepage-todo-list',
          });
          trackClicked();
        }}
      >
        {translate('title')}
      </Link>
    </TodoListItem>
  );
};
